<template>
  <div class="wrap">
    <st-header
      title="我的工单"
      :back-able="true"
    >
    </st-header>

    <div class="subCenter">
      <Submit1 ref="sub1" :base-form-data="formData" @next="next"/>
      <Submit2 :base-form-data="formData" @prev='prev' @submit="submit"/>
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import Submit1 from "./submit1/Submit1.vue";
import Submit2 from './submit1/Submit2.vue'
//import Submit2 from './submit2/Submit2.vue'
export default {
  components: {
    "st-header": StHeader,
    Submit1,
    Submit2,
  },
  props: {},
  data() {
    return {
      isShow: true,
      formData: {},
      code: '',
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  watch: {
  },

  methods: {
    init() {
      this.code = this.$route.params['id'];
    },
    prev(formData) {
      this.isShow = true
      this.formData = formData;
    },
    next(formData) {
      this.isShow = false
      this.formData = formData;
    },

    async submit(formData) {
      if (
        !formData.connect ||
        !formData.phone ||
        !formData.sales_feedback
      ) {
        this.$toast.fail('*必填项不能为空');
        return
      } 

      formData['ordercode'] = this.code;
      await this.$post(this.$api.stRmaOrderAdd, formData).then((res) => {
        if (res.code == 1) {
          this.$toast.success("提交成功");
          this.$router.push("/saleRep/order/all/" + this.code);
        } else {
          this.$toast.fail(res['msg']);
        }
      }).catch((e) => {
        console.log(e);
      })
      
    },

  },
};
</script>

<style lang="scss">
div {
  box-sizing: border-box;
}
.subCenter {
  padding: 15px 24px 0px;
  height: 94vh;
  background: rgba(243, 246, 250, 1);
}
.red {
  color: #ff5733;
}
</style>
